import { toast } from "sonner";

export const SITE_NAME = "Real Estate with Ayush";
// Use the actual host the visitor is on (works on preview, .emergent.host, and custom domain).
export const SITE_URL = typeof window !== "undefined" ? window.location.origin : "";

// White-labelled share: appends the brand + site to whatever is shared.
export async function shareLink({ title, url = "", note = "" }) {
  const brand = `via ${SITE_NAME} · ${SITE_URL}`;
  const text = `${title}${note ? `\n${note}` : ""}\n${brand}`;
  try {
    if (navigator.share) {
      await navigator.share({ title, text, url: url || SITE_URL });
      return;
    }
  } catch (e) {
    if (e && e.name === "AbortError") return; // user cancelled
  }
  try {
    await navigator.clipboard.writeText(`${title}${url ? `\n${url}` : ""}\n${brand}`);
    toast.success("Link copied — share it anywhere!");
  } catch (e) {
    toast.error("Couldn't share on this browser.");
  }
}
